import EntityCrudPage from '../../shared/EntityCrudPage';
import { businessUnitConfig } from '../../config/entityConfigs';

const BusinessUnitsPage = () => <EntityCrudPage config={businessUnitConfig} />;

export default BusinessUnitsPage;
